module.exports = __webpack_public_path__ + "img/antiseptics.de5bc5fa.jpg";